{
  "min": 0,
  "max": 0,
  "R": [0, 37],
  "G": [242, 0],
  "B": [255, 255],
  "A": [0, 64],
  "I": [0, 255]
}
